module.exports = __webpack_public_path__ + "media/react/components/DailySequence/Slider/assets/exercise_bike-fbfc58e6816d28529130979cababef27.svg";